import { ApiProperty } from "@nestjs/swagger";

export class RmActualCountDto {
    @ApiProperty()
    grnItemId: number;
    @ApiProperty()
    actualCount: number;
    @ApiProperty()
    actualQuantity: number;
}